export default {
  mounted() {
    const to = this.el.getAttribute('copy-from')
    this.el.addEventListener('click', (ev) => {
      ev.preventDefault()
      let text = document.getElementById(to).innerText
      navigator.clipboard.writeText(text).then(() => {})
    })
  }
}
